import React, { Component } from 'react'
import { Card } from 'react-bootstrap';

export class cardPrincipalReport extends Component {
    render() {
        const { texto } = this.props;
        const { variant } = this.props;
        const { titulo } = this.props;
        const { cantidad } = this.props;
        return (
            <Card
                bg={variant}
                text={'white'}
                style={{ width: '30rem' }}
                className="m-2"
            >
                <Card.Header>{titulo}</Card.Header>
                <Card.Body>
                    <Card.Text>
                        {texto}
                    </Card.Text>
                </Card.Body>
                <Card.Footer><b>{cantidad}</b></Card.Footer>
            </Card>
        )
    }
}

export default cardPrincipalReport
